import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Compass, NotebookPen, Gamepad2, Ticket, User } from "lucide-react";
import { useT } from "@/lib/i18n";

/** iOS-style bottom tab bar rendered only on mobile (< md).
 * Hidden on dedicated full-screen flows (home chat, course journey) where
 * the UI already provides its own composer / action bar at the bottom.
 */
export const tabsHiddenOn = (pathname) => pathname === "/" || pathname.startsWith("/courses/");

const TAB_LABELS = {
  fr: ["Découvrir", "Carnet", "Play", "Experience", "Compte"],
  en: ["Discover", "Notebook", "Play", "Experience", "Account"],
  es: ["Descubrir", "Cuaderno", "Play", "Experience", "Cuenta"],
  pt: ["Descobrir", "Caderno", "Play", "Experience", "Conta"],
};

export default function MobileBottomTabs() {
  const loc = useLocation();
  const { lang } = useT();
  if (tabsHiddenOn(loc.pathname)) return null;
  const L = TAB_LABELS[lang] || TAB_LABELS.fr;
  const tabs = [
    { to: "/discover", label: L[0], icon: Compass, testid: "tab-discover" },
    { to: "/carnet", label: L[1], icon: NotebookPen, testid: "tab-carnet" },
    { to: "/play", label: L[2], icon: Gamepad2, testid: "tab-play" },
    { to: "/experience", label: L[3], icon: Ticket, testid: "tab-experience" },
    { to: "/account", label: L[4], icon: User, testid: "tab-account" },
  ];
  return (
    <nav
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-xl border-t border-[#1F3A5F]/8"
      style={{ paddingBottom: "var(--safe-bottom)" }}
      data-testid="mobile-bottom-tabs"
    >
      <div className="flex items-stretch justify-around px-1 h-14">
        {tabs.map(({ to, label, icon: Icon, testid }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={testid}
            className={({ isActive }) =>
              `flex-1 flex flex-col items-center justify-center gap-0.5 py-1 px-1 rounded-lg text-[10px] font-medium transition-colors ${
                isActive ? "text-[#E5276A]" : "text-[#5B6774]"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <Icon className={`w-5 h-5 ${isActive ? "stroke-[2.5]" : ""}`} />
                <span className="tracking-tight">{label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
